/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Technologies_Generatedon1Inputs */

const en_us2_technologies_generatedon1 = /** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generated ${i?.date}`)
};

const es_es2_technologies_generatedon1 = /** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generado el ${i?.date}`)
};

const ru_technologies_generatedon1 = /** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сгенерировано ${i?.date}`)
};

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const id_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const ms_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const da_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const de_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const es_mx2_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const fil_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const fr_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const it_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const hu_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const nl_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const no_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const pl_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const pt_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const pt_br2_technologies_generatedon1 = pt_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const ro_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const fi_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const sv_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const vi_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const tr_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const cs_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const bg_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const uk_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const ar_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const hi_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const th_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const ja_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const zh_cn2_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const zh_hant1_technologies_generatedon1 = en_us2_technologies_generatedon1;

/** @type {(inputs: Technologies_Generatedon1Inputs) => LocalizedString} */
const ko_technologies_generatedon1 = en_us2_technologies_generatedon1;

/**
* | output |
* | --- |
* | "Generated {date}" |
*
* @param {Technologies_Generatedon1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_generatedon1 = /** @type {((inputs: Technologies_Generatedon1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_Generatedon1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_generatedon1(inputs)
	if (locale === "ms") return ms_technologies_generatedon1(inputs)
	if (locale === "da") return da_technologies_generatedon1(inputs)
	if (locale === "de") return de_technologies_generatedon1(inputs)
	if (locale === "en-US") return en_us2_technologies_generatedon1(inputs)
	if (locale === "es-ES") return es_es2_technologies_generatedon1(inputs)
	if (locale === "es-MX") return es_mx2_technologies_generatedon1(inputs)
	if (locale === "fil") return fil_technologies_generatedon1(inputs)
	if (locale === "fr") return fr_technologies_generatedon1(inputs)
	if (locale === "it") return it_technologies_generatedon1(inputs)
	if (locale === "hu") return hu_technologies_generatedon1(inputs)
	if (locale === "nl") return nl_technologies_generatedon1(inputs)
	if (locale === "no") return no_technologies_generatedon1(inputs)
	if (locale === "pl") return pl_technologies_generatedon1(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_generatedon1(inputs)
	if (locale === "pt") return pt_technologies_generatedon1(inputs)
	if (locale === "ro") return ro_technologies_generatedon1(inputs)
	if (locale === "fi") return fi_technologies_generatedon1(inputs)
	if (locale === "sv") return sv_technologies_generatedon1(inputs)
	if (locale === "vi") return vi_technologies_generatedon1(inputs)
	if (locale === "tr") return tr_technologies_generatedon1(inputs)
	if (locale === "cs") return cs_technologies_generatedon1(inputs)
	if (locale === "bg") return bg_technologies_generatedon1(inputs)
	if (locale === "ru") return ru_technologies_generatedon1(inputs)
	if (locale === "uk") return uk_technologies_generatedon1(inputs)
	if (locale === "ar") return ar_technologies_generatedon1(inputs)
	if (locale === "hi") return hi_technologies_generatedon1(inputs)
	if (locale === "th") return th_technologies_generatedon1(inputs)
	if (locale === "ja") return ja_technologies_generatedon1(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_generatedon1(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_generatedon1(inputs)
	return ko_technologies_generatedon1(inputs)
});
export { technologies_generatedon1 as "technologies.generatedOn" }